export const architectureConst = {
  path: "/single-programs/architecture",
  title: "ФАКУЛЬТЕТ АРХИТЕКТУРЫ – АРХИТЕКТУРА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Архитектура — искусство и технология создания пространства</h2>
      <p>
        Программа охватывает полный цикл архитектурного проектирования — от идеи до реализации. Особое внимание уделяется художественной
        выразительности, композиции, визуализации и техническому исполнению. Студенты изучают как классические архитектурные стили, так и
        современные концепции устойчивого проектирования.
      </p>
      <p>Образование построено на гармоничном сочетании креативного подхода и инженерной точности.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Архитектурное проектирование</li>
        <li>История и теория архитектуры</li>
        <li>Композиция, черчение и макетирование</li>
        <li>Цифровое моделирование и визуализация (AutoCAD, Revit, SketchUp, Rhino)</li>
        <li>Технологии и материалы в строительстве</li>
        <li>Ландшафтная архитектура</li>
        <li>Градостроительство и урбанистика</li>
        <li>Энергоэффективное проектирование и стандарты ЕС</li>
      </ul>
      <p>
        Программа предполагает участие в архитектурных конкурсах, формирование портфолио, реальные проекты и стажировки в архитектурных бюро
        Европы.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Архитектор</li>
        <li>Архитектор-дизайнер</li>
        <li>Визуализатор архитектурных проектов</li>
        <li>Автор концептуальных решений и городских пространств</li>
        <li>Специалист по 3D-моделированию</li>
        <li>Преподаватель или исследователь в области архитектуры</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с высоким статусом</li>
        <li>Гибкие форматы обучения: онлайн или очно</li>
        <li>Преподаватели — практикующие архитекторы</li>
        <li>Портфолио и реальные проекты уже с первого года</li>
        <li>Обучение на русском или английском языке</li>
        <li>Поддержка приемной комиссии от первого шага до зачисления</li>
      </ul>
      <p>Архитектура — это профессия, которая оставляет след</p>
      <p>
        Наши выпускники создают здания, которыми гордятся города. Их работы побеждают в конкурсах и украшают портфолио ведущих архитектурных
        студий Европы.
      </p>
      <br />
      <p className="padding-left">
        «Архитектор — это художник, инженер и визионер в одном лице. Мы готовим тех, кто создает будущее пространств.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом этапе — от выбора направления до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Архитектура — искусство и технология создания пространства
    Программа охватывает полный цикл архитектурного проектирования — от идеи до реализации. Особое внимание уделяется художественной выразительности, композиции, визуализации и техническому исполнению. Студенты изучают как классические архитектурные стили, так и современные концепции устойчивого проектирования.
    Образование построено на гармоничном сочетании креативного подхода и инженерной точности.
    Что вы будете изучать?
    • Архитектурное проектирование
    • История и теория архитектуры
    • Композиция, черчение и макетирование
    • Цифровое моделирование и визуализация (AutoCAD, Revit, SketchUp, Rhino)
    • Технологии и материалы в строительстве
    • Ландшафтная архитектура
    • Градостроительство и урбанистика
    • Энергоэффективное проектирование и стандарты ЕС
    Программа предполагает участие в архитектурных конкурсах, формирование портфолио, реальные проекты и стажировки в архитектурных бюро Европы.
    Кем можно работать после окончания?
    • Архитектор
    • Архитектор-дизайнер
    • Визуализатор архитектурных проектов
    • Автор концептуальных решений и городских пространств
    • Специалист по 3D-моделированию
    • Преподаватель или исследователь в области архитектуры
    Зарплата в Европе: от €55,000 до €100,000 в год
    Почему выбирают нас?
    • Европейский диплом с высоким статусом
    • Гибкие форматы обучения: онлайн или очно
    • Преподаватели — практикующие архитекторы
    • Портфолио и реальные проекты уже с первого года
    • Обучение на русском или английском языке
    • Поддержка приемной комиссии от первого шага до зачисления
    Архитектура — это профессия, которая оставляет след
    Наши выпускники создают здания, которыми гордятся города. Их работы побеждают в конкурсах и украшают портфолио ведущих архитектурных студий Европы.
    «Архитектор — это художник, инженер и визионер в одном лице. Мы готовим тех, кто создает будущее пространств.»

    Как поступить?
    Приёмная комиссия сопровождает вас на каждом этапе — от выбора направления до подачи заявки.
  `,
};
